module.exports = __webpack_public_path__ + "static/logo-db04f0629158d6d710eca5310303a661.png";